export const createInactiveSchedulerFilters = (set, get) => ({
    inActiveSchedulerFilters: {  
        searchName: undefined,
        userType: undefined,
    },
    setInActiveSchedulerFilters: (newFilter) =>
        set((state) => ({
            inActiveSchedulerFilters: {
                ...state.inActiveSchedulerFilters,
                ...newFilter,
            },
        })),
});



// WEBPACK FOOTER //
// ./src/store/slices/InActiveSchedulerSlice/inActiveSchedulerSlice.js